import React from "react";
import PropTypes from 'prop-types';

const LoadMoreButton = ({ top, skip, setSkip, classNames }) => {
  const clickHandler = () => {
    setSkip(skip + top);
  }

  return (
    <button
      className={`govuk-button he-button he-button__primary ${classNames ?? ''}`}
      onClick={clickHandler}
      data-component="ugcLoadMoreCommentsButton">
      Load more
    </button>
  )
};

LoadMoreButton.propTypes = {
  top: PropTypes.number.isRequired,
  skip: PropTypes.number.isRequired,
  setSkip: PropTypes.func.isRequired,
  classNames: PropTypes.string
};

export default LoadMoreButton;
